import { Button } from '../buttons';
import styled from 'styled-components';

export const SectionFooter = styled.div`
    padding: 16px 24px;
    position: relative;
    display: flex;

    ${Button} {
        min-width: 250px;
    }
`;

export const SectionFooterLeft = styled.div`
    flex: 1;
    display: flex;
    gap: 18px;
`;

export const SectionFooterRight = styled.div`
    flex: 1;
    display: flex;
    gap: 18px;
    justify-content: end;
`;

export const PrimaryButtonWrapper = styled.div`
    width: fit-content;
`;
